<template>
    <div class="form-edit-page">
        <div class="page-header">
            <h1>Módulo de Protocolo de Registro de Estabelecimentos</h1>
            <p>Controle operacional do processo de registro de estabelecimentos no SIM.</p>
        </div>

        <section class="form-card">
            <div class="section-title">Abertura / Edição do Protocolo</div>

            <div class="row">
                <div class="form-item col-2">
                    <label>Número do Protocolo</label>
                    <input v-model="form.numeroProtocolo" type="text" placeholder="Ex.: 2026/0001" />
                </div>

                <div class="form-item col-1">
                    <label>Data de Abertura</label>
                    <input v-model="form.dataAbertura" type="date" />
                </div>

                <div class="form-item col-2">
                    <label>Estabelecimento</label>
                    <select v-model="form.idEstabelecimento">
                        <option :value="0">Selecione...</option>
                        <option
                            v-for="item in lsEstabelecimentos"
                            :key="item.id"
                            :value="item.id"
                        >
                            {{ item.nome }}
                        </option>
                    </select>
                </div>

                <div class="form-item col-1">
                    <label>CNPJ</label>
                    <input :value="cnpjEstabelecimentoSelecionado" type="text" readonly />
                </div>
            </div>

            <div class="row">
                <div class="form-item col-1">
                    <label>Tipo de Solicitação</label>
                    <select v-model="form.tipoSolicitacao">
                        <option value="REGISTRO_INICIAL">Registro Inicial</option>
                        <option value="RENOVACAO">Renovação</option>
                        <option value="ALTERACAO_CADASTRAL">Alteração Cadastral</option>
                    </select>
                </div>

                <div class="form-item col-1">
                    <label>Situação</label>
                    <select v-model="form.situacao">
                        <option value="ABERTO">Aberto</option>
                        <option value="EM_ANALISE">Em análise</option>
                        <option value="PENDENTE">Pendente</option>
                        <option value="DEFERIDO">Deferido</option>
                        <option value="INDEFERIDO">Indeferido</option>
                    </select>
                </div>

                <div class="form-item col-1">
                    <label>Responsável</label>
                    <input v-model="form.responsavel" type="text" placeholder="Nome do responsável" />
                </div>

                <div class="form-item col-1">
                    <label>Previsão de Vistoria</label>
                    <input v-model="form.dataPrevistaVistoria" type="date" />
                </div>
            </div>

            <div class="row">
                <div class="form-item col-4">
                    <label>Observações</label>
                    <textarea
                        v-model="form.observacoes"
                        rows="3"
                        placeholder="Informações complementares sobre o protocolo..."
                    ></textarea>
                </div>
            </div>

            <div class="actions">
                <button class="btn btn-primary" @click="salvarMock">Salvar</button>
                <button class="btn btn-secondary" @click="novoRegistro">Novo</button>
            </div>
        </section>

        <section class="grid-card">
            <div class="section-title">Processos de Registro</div>

            <table class="data-table">
                <thead>
                    <tr>
                        <th>Protocolo</th>
                        <th>Data</th>
                        <th>Estabelecimento</th>
                        <th>Tipo</th>
                        <th>Situação</th>
                        <th>Responsável</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in lsProcessos"
                        :key="item.id"
                        class="row-clickable"
                        :class="{ selected: processoSelecionado && processoSelecionado.id === item.id }"
                        @click="selecionarProcesso(item)"
                    >
                        <td>{{ item.numeroProtocolo }}</td>
                        <td>{{ formatarData(item.dataAbertura) }}</td>
                        <td>{{ item.estabelecimento }}</td>
                        <td>{{ formatarTipo(item.tipoSolicitacao) }}</td>
                        <td>
                            <span class="tag" :class="getClasseSituacao(item.situacao)">
                                {{ formatarSituacao(item.situacao) }}
                            </span>
                        </td>
                        <td>{{ item.responsavel }}</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <template v-if="processoSelecionado">
            <section class="form-card">
                <div class="section-title">
                    Checklist do Processo - {{ processoSelecionado.numeroProtocolo }}
                </div>

                <table class="data-table">
                    <thead>
                        <tr>
                            <th style="width: 35%">Item</th>
                            <th style="width: 18%">Status</th>
                            <th>Observação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in checklistEditavel" :key="item.id">
                            <td>{{ item.item }}</td>
                            <td>
                                <select v-model="item.status">
                                    <option value="PENDENTE">Pendente</option>
                                    <option value="OK">OK</option>
                                    <option value="REPROVADO">Reprovado</option>
                                </select>
                            </td>
                            <td>
                                <input
                                    v-model="item.observacao"
                                    type="text"
                                    placeholder="Informe uma observação"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="actions">
                    <button class="btn btn-primary" @click="salvarChecklist">
                        Salvar Checklist
                    </button>
                    <button class="btn btn-secondary" @click="restaurarChecklist">
                        Restaurar
                    </button>
                </div>
            </section>

            <section class="form-card">
                <div class="section-title">
                    Nova Movimentação - {{ processoSelecionado.numeroProtocolo }}
                </div>

                <div class="row">
                    <div class="form-item col-1">
                        <label>Ação</label>
                        <select v-model="historicoForm.acao">
                            <option value="ANÁLISE DOCUMENTAL">Análise documental</option>
                            <option value="PENDÊNCIA">Pendência</option>
                            <option value="VISTORIA">Vistoria</option>
                            <option value="PARECER">Parecer</option>
                            <option value="DEFERIMENTO">Deferimento</option>
                            <option value="INDEFERIMENTO">Indeferimento</option>
                            <option value="OBSERVAÇÃO">Observação</option>
                        </select>
                    </div>

                    <div class="form-item col-1">
                        <label>Usuário</label>
                        <input v-model="historicoForm.usuario" type="text" placeholder="Usuário responsável" />
                    </div>
                </div>

                <div class="row">
                    <div class="form-item col-4">
                        <label>Descrição</label>
                        <textarea
                            v-model="historicoForm.descricao"
                            rows="3"
                            placeholder="Descreva a movimentação realizada no processo"
                        ></textarea>
                    </div>
                </div>

                <div class="actions">
                    <button class="btn btn-primary" @click="adicionarHistorico">
                        Adicionar Movimentação
                    </button>
                    <button class="btn btn-secondary" @click="limparHistoricoForm">
                        Limpar
                    </button>
                </div>
            </section>

            <section class="form-card">
                <div class="section-title">
                    Histórico do Processo - {{ processoSelecionado.numeroProtocolo }}
                </div>

                <div class="timeline">
                    <div
                        v-for="item in processoSelecionado.historico"
                        :key="item.id"
                        class="timeline-item"
                    >
                        <div class="timeline-dot"></div>

                        <div class="timeline-content">
                            <div class="timeline-top">
                                <strong>{{ item.acao }}</strong>
                                <span>{{ item.data }}</span>
                            </div>

                            <div class="timeline-user">
                                Usuário: {{ item.usuario }}
                            </div>

                            <div class="timeline-description">
                                {{ item.descricao }}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'

const lsEstabelecimentos = ref([
    { id: 1, nome: 'Agroindústria Bom Sabor Ltda', cnpj: '12.345.678/0001-10' },
    { id: 2, nome: 'Laticínios Vale do Sul', cnpj: '22.111.333/0001-55' },
    { id: 3, nome: 'Entreposto de Mel Santa Serra', cnpj: '55.888.999/0001-02' }
])

function criarFormulario() {
    return {
        id: 0,
        numeroProtocolo: '',
        dataAbertura: '2026-03-19',
        idEstabelecimento: 0,
        tipoSolicitacao: 'REGISTRO_INICIAL',
        situacao: 'ABERTO',
        responsavel: '',
        dataPrevistaVistoria: '',
        observacoes: ''
    }
}

function criarHistoricoForm() {
    return {
        acao: 'ANÁLISE DOCUMENTAL',
        usuario: '',
        descricao: ''
    }
}

const form = reactive(criarFormulario())
const historicoForm = reactive(criarHistoricoForm())

const lsProcessos = ref([
    {
        id: 1,
        numeroProtocolo: '2026/0001',
        dataAbertura: '2026-03-10',
        idEstabelecimento: 1,
        estabelecimento: 'Agroindústria Bom Sabor Ltda',
        tipoSolicitacao: 'REGISTRO_INICIAL',
        situacao: 'EM_ANALISE',
        responsavel: 'Carlos Mendes',
        dataPrevistaVistoria: '2026-03-25',
        observacoes: 'Processo em análise documental.',
        checklist: [
            { id: 1, item: 'Requerimento de registro', status: 'OK', observacao: '' },
            { id: 2, item: 'CNPJ do estabelecimento', status: 'OK', observacao: '' },
            { id: 3, item: 'Licença ambiental', status: 'PENDENTE', observacao: 'Apresentar renovação vigente.' },
            { id: 4, item: 'ART do responsável técnico', status: 'OK', observacao: '' },
            { id: 5, item: 'Memorial descritivo', status: 'OK', observacao: '' }
        ],
        historico: [
            { id: 1, data: '10/03/2026 09:10', acao: 'Abertura', usuario: 'Supervisor SIM', descricao: 'Protocolo aberto no sistema.' },
            { id: 2, data: '11/03/2026 14:22', acao: 'Análise documental', usuario: 'Fiscal Ana', descricao: 'Documentação preliminar conferida.' },
            { id: 3, data: '12/03/2026 16:05', acao: 'Pendência', usuario: 'Fiscal Ana', descricao: 'Licença ambiental com validade expirada.' }
        ]
    },
    {
        id: 2,
        numeroProtocolo: '2026/0002',
        dataAbertura: '2026-03-12',
        idEstabelecimento: 2,
        estabelecimento: 'Laticínios Vale do Sul',
        tipoSolicitacao: 'RENOVACAO',
        situacao: 'PENDENTE',
        responsavel: 'Mariana Costa',
        dataPrevistaVistoria: '2026-03-28',
        observacoes: 'Aguardando documentos complementares.',
        checklist: [
            { id: 1, item: 'Requerimento de renovação', status: 'OK', observacao: '' },
            { id: 2, item: 'Comprovante de inspeção anterior', status: 'OK', observacao: '' },
            { id: 3, item: 'PAC atualizado', status: 'PENDENTE', observacao: 'Enviar versão assinada.' }
        ],
        historico: [
            { id: 1, data: '12/03/2026 08:45', acao: 'Abertura', usuario: 'Atendimento', descricao: 'Processo de renovação registrado.' },
            { id: 2, data: '13/03/2026 10:20', acao: 'Pendência documental', usuario: 'Fiscal João', descricao: 'Solicitado envio do PAC atualizado.' }
        ]
    }
])

const processoSelecionado = ref(lsProcessos.value[0] || null)
const checklistEditavel = ref([])

const cnpjEstabelecimentoSelecionado = computed(() => {
    const estabelecimento = lsEstabelecimentos.value.find(x => x.id === form.idEstabelecimento)
    return estabelecimento ? estabelecimento.cnpj : ''
})

function formatarTipo(valor) {
    const tipos = {
        REGISTRO_INICIAL: 'Registro inicial',
        RENOVACAO: 'Renovação',
        ALTERACAO_CADASTRAL: 'Alteração cadastral'
    }
    return tipos[valor] || valor
}

function formatarSituacao(valor) {
    const situacoes = {
        ABERTO: 'Aberto',
        EM_ANALISE: 'Em análise',
        PENDENTE: 'Pendente',
        DEFERIDO: 'Deferido',
        INDEFERIDO: 'Indeferido'
    }
    return situacoes[valor] || valor
}

function getClasseSituacao(valor) {
    return {
        'tag-open': valor === 'ABERTO',
        'tag-analysis': valor === 'EM_ANALISE',
        'tag-pending': valor === 'PENDENTE',
        'tag-approved': valor === 'DEFERIDO',
        'tag-denied': valor === 'INDEFERIDO'
    }
}

function formatarData(dataIso) {
    if (!dataIso) return ''
    const partes = dataIso.split('-')
    if (partes.length !== 3) return dataIso
    return `${partes[2]}/${partes[1]}/${partes[0]}`
}

function getDataHoraAtual() {
    const agora = new Date()

    const dia = String(agora.getDate()).padStart(2, '0')
    const mes = String(agora.getMonth() + 1).padStart(2, '0')
    const ano = agora.getFullYear()
    const hora = String(agora.getHours()).padStart(2, '0')
    const minuto = String(agora.getMinutes()).padStart(2, '0')

    return `${dia}/${mes}/${ano} ${hora}:${minuto}`
}

function clonarChecklist(lista) {
    return (lista || []).map(item => ({ ...item }))
}

function carregarChecklistEditavel() {
    checklistEditavel.value = clonarChecklist(processoSelecionado.value?.checklist || [])
}

function selecionarProcesso(item) {
    processoSelecionado.value = item

    form.id = item.id
    form.numeroProtocolo = item.numeroProtocolo
    form.dataAbertura = item.dataAbertura
    form.idEstabelecimento = item.idEstabelecimento
    form.tipoSolicitacao = item.tipoSolicitacao
    form.situacao = item.situacao
    form.responsavel = item.responsavel
    form.dataPrevistaVistoria = item.dataPrevistaVistoria
    form.observacoes = item.observacoes

    carregarChecklistEditavel()
    limparHistoricoForm()
}

function novoRegistro() {
    Object.assign(form, criarFormulario())
    Object.assign(historicoForm, criarHistoricoForm())
    processoSelecionado.value = null
    checklistEditavel.value = []
}

function salvarMock() {
    const estabelecimento = lsEstabelecimentos.value.find(x => x.id === form.idEstabelecimento)

    if (!form.id) {
        const novo = {
            id: Date.now(),
            numeroProtocolo: form.numeroProtocolo,
            dataAbertura: form.dataAbertura,
            idEstabelecimento: form.idEstabelecimento,
            estabelecimento: estabelecimento ? estabelecimento.nome : '',
            tipoSolicitacao: form.tipoSolicitacao,
            situacao: form.situacao,
            responsavel: form.responsavel,
            dataPrevistaVistoria: form.dataPrevistaVistoria,
            observacoes: form.observacoes,
            checklist: [
                { id: 1, item: 'Requerimento de registro', status: 'PENDENTE', observacao: '' },
                { id: 2, item: 'CNPJ do estabelecimento', status: 'PENDENTE', observacao: '' },
                { id: 3, item: 'Licença ambiental', status: 'PENDENTE', observacao: '' },
                { id: 4, item: 'ART do responsável técnico', status: 'PENDENTE', observacao: '' },
                { id: 5, item: 'Memorial descritivo', status: 'PENDENTE', observacao: '' }
            ],
            historico: [
                {
                    id: 1,
                    data: getDataHoraAtual(),
                    acao: 'Abertura',
                    usuario: 'Usuário logado',
                    descricao: 'Processo criado manualmente na POC.'
                }
            ]
        }

        lsProcessos.value.unshift(novo)
        selecionarProcesso(novo)
        return
    }

    const idx = lsProcessos.value.findIndex(x => x.id === form.id)
    if (idx >= 0) {
        lsProcessos.value[idx] = {
            ...lsProcessos.value[idx],
            numeroProtocolo: form.numeroProtocolo,
            dataAbertura: form.dataAbertura,
            idEstabelecimento: form.idEstabelecimento,
            estabelecimento: estabelecimento ? estabelecimento.nome : '',
            tipoSolicitacao: form.tipoSolicitacao,
            situacao: form.situacao,
            responsavel: form.responsavel,
            dataPrevistaVistoria: form.dataPrevistaVistoria,
            observacoes: form.observacoes
        }

        selecionarProcesso(lsProcessos.value[idx])
    }
}

function salvarChecklist() {
    if (!processoSelecionado.value) return

    const idx = lsProcessos.value.findIndex(x => x.id === processoSelecionado.value.id)
    if (idx < 0) return

    lsProcessos.value[idx].checklist = clonarChecklist(checklistEditavel.value)

    const qtdPendentes = checklistEditavel.value.filter(x => x.status === 'PENDENTE').length
    const qtdReprovados = checklistEditavel.value.filter(x => x.status === 'REPROVADO').length

    if (qtdReprovados > 0) {
        lsProcessos.value[idx].situacao = 'PENDENTE'
        form.situacao = 'PENDENTE'
    } else if (qtdPendentes === 0 && checklistEditavel.value.length > 0) {
        lsProcessos.value[idx].situacao = 'EM_ANALISE'
        form.situacao = 'EM_ANALISE'
    }

    lsProcessos.value[idx].historico.unshift({
        id: Date.now(),
        data: getDataHoraAtual(),
        acao: 'Checklist atualizado',
        usuario: 'Usuário logado',
        descricao: 'Checklist documental/técnico atualizado no processo.'
    })

    processoSelecionado.value = lsProcessos.value[idx]
    carregarChecklistEditavel()
}

function restaurarChecklist() {
    carregarChecklistEditavel()
}

function limparHistoricoForm() {
    Object.assign(historicoForm, criarHistoricoForm())
}

function adicionarHistorico() {
    if (!processoSelecionado.value) return
    if (!historicoForm.usuario || !historicoForm.descricao) return

    const idx = lsProcessos.value.findIndex(x => x.id === processoSelecionado.value.id)
    if (idx < 0) return

    lsProcessos.value[idx].historico.unshift({
        id: Date.now(),
        data: getDataHoraAtual(),
        acao: historicoForm.acao,
        usuario: historicoForm.usuario,
        descricao: historicoForm.descricao
    })

    if (historicoForm.acao === 'DEFERIMENTO') {
        lsProcessos.value[idx].situacao = 'DEFERIDO'
        form.situacao = 'DEFERIDO'
    } else if (historicoForm.acao === 'INDEFERIMENTO') {
        lsProcessos.value[idx].situacao = 'INDEFERIDO'
        form.situacao = 'INDEFERIDO'
    } else if (historicoForm.acao === 'PENDÊNCIA') {
        lsProcessos.value[idx].situacao = 'PENDENTE'
        form.situacao = 'PENDENTE'
    }

    processoSelecionado.value = lsProcessos.value[idx]
    limparHistoricoForm()
}

if (processoSelecionado.value) {
    selecionarProcesso(processoSelecionado.value)
}
</script>

<style scoped>
.form-edit-page {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #f7f8fa;
}

.page-header h1 {
    margin: 0 0 4px;
    font-size: 24px;
}

.page-header p {
    margin: 0;
    color: #666;
}

.form-card,
.grid-card {
    background: #fff;
    border: 1px solid #dfe3e8;
    border-radius: 10px;
    padding: 16px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 14px;
}

.row {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    flex-wrap: wrap;
}

.form-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-item label {
    font-size: 13px;
    font-weight: 600;
    color: #333;
}

.form-item input,
.form-item select,
.form-item textarea {
    width: 100%;
    border: 1px solid #cfd6dd;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    box-sizing: border-box;
    background: #fff;
}

.form-item textarea {
    resize: vertical;
}

.col-1 { flex: 1 1 220px; }
.col-2 { flex: 2 1 320px; }
.col-4 { flex: 4 1 100%; }

.actions {
    display: flex;
    gap: 10px;
    margin-top: 12px;
    flex-wrap: wrap;
}

.btn {
    border: none;
    border-radius: 8px;
    padding: 10px 18px;
    cursor: pointer;
    font-weight: 600;
}

.btn-primary {
    background: #2563eb;
    color: #fff;
}

.btn-secondary {
    background: #e5e7eb;
    color: #111827;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
}

.data-table th,
.data-table td {
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    text-align: left;
    font-size: 14px;
    vertical-align: top;
}

.data-table td select,
.data-table td input {
    width: 100%;
    border: 1px solid #cfd6dd;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 14px;
    box-sizing: border-box;
}

.row-clickable {
    cursor: pointer;
}

.row-clickable:hover {
    background: #f8fafc;
}

.selected {
    background: #eef4ff;
}

.tag {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
}

.tag-open {
    background: #e0f2fe;
    color: #075985;
}

.tag-analysis {
    background: #fef3c7;
    color: #92400e;
}

.tag-pending {
    background: #fee2e2;
    color: #991b1b;
}

.tag-approved {
    background: #dcfce7;
    color: #166534;
}

.tag-denied {
    background: #ede9fe;
    color: #5b21b6;
}

.timeline {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.timeline-item {
    display: flex;
    gap: 12px;
    align-items: flex-start;
}

.timeline-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #2563eb;
    margin-top: 6px;
    flex-shrink: 0;
}

.timeline-content {
    flex: 1;
    border-left: 2px solid #e5e7eb;
    padding-left: 12px;
    padding-bottom: 12px;
}

.timeline-top {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 4px;
    flex-wrap: wrap;
}

.timeline-top strong {
    font-size: 14px;
}

.timeline-top span {
    font-size: 12px;
    color: #666;
}

.timeline-user {
    font-size: 13px;
    color: #555;
    margin-bottom: 4px;
}

.timeline-description {
    font-size: 14px;
    color: #222;
}
</style>